import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/storage";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCVDjBUPB5hXVxEHCh9geU_srOf-jRsnU4",
  authDomain: "tom-wedge-images.firebaseapp.com",
  databaseURL: "https://tom-wedge-images.firebaseio.com",
  projectId: "tom-wedge-images",
  storageBucket: "tom-wedge-images.appspot.com",
  messagingSenderId: "404940115322",
  appId: "1:404940115322:web:f395a9108bfd0a1ef09ac3",
  measurementId: "G-SPSXP40WR0",
};
// Initialize Firebase
var firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();

// const db = firebase.firestore();

// const storage = firebaseApp.storage().ref();

export default firebaseApp;
// export default storage;
